/* eslint-disable */
export default {
    cp_filter_menu_organisation: "Organisation",
    cp_filter_menu_status: "Status",
    cp_filter_menu_suborganisation: "Suborganisation",
    cp_filter_menu_product: "Product",
    cp_filter_menu_project: "Project",
    cp_filter_menu_date_completed: "Date completed",
    cp_filter_menu_date_added: "Date added",
    cp_filter_menu_to_section: "To section",
    cp_filter_menu_less: "Less",
    cp_filter_menu_more: "More",
    cp_filter_menu_search: "Search...",
    cp_filter_menu_start_date: "Start date",
    cp_filter_menu_end_date: "End date",
    cp_filter_menu_could_not_fetch_organisations: "Could not fetch organisations",
    cp_filter_menu_items_fetch_error: "Something went wrong while fetching filter menu items.",
    cp_filter_menu_selected_filters: "Selected filters:",
    cp_filter_menu_no_results: "No results",
    cp_filter_menu_no_filter_selected: "No filter selected",
    cp_filter_menu_planning_filter_to_be_planned: "",
    cp_filter_menu_planning_filter_planned: "",
    cp_filter_menu_planning_filter_report_in_preparation: "",
    cp_filter_menu_planning_filter_report_shared: "Rapport partagé",
    cp_filter_menu_consultants: "",
    cp_filter_menu_costHeadings: "",
    cp_filter_menu_appointment_date: "Appointment date",
    cp_filter_menu_appointment_date_from: "From",
    cp_filter_menu_appointment_date_until: "Until",
    cp_filter_menu_assessment_outcome_filter_in_consideration: "En considération",
    cp_filter_menu_assessment_outcome_filter_positive: "Positif",
    cp_filter_menu_assessment_outcome_filter_negative: "Négatif",
    cp_filter_menu_assessment_outcome_filter_neutral: "Neutre",
    cp_filter_menu_assessment_outcome_filter_unknown: "Inconnu",
    cp_filter_menu_outcome: ""
};
